import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Share Controller
// Provides share/copy behavior with a Bootstrap toast confirmation.
export default class extends Controller {
    static values = {
        title: String,
        url: String,
        successText: { type: String, default: 'Link copied' },
        failText: { type: String, default: 'Copy failed' }
    }

    share(event) {
        event.preventDefault()
        const title = this.hasTitleValue ? this.titleValue : document.title
        const url = this.hasUrlValue ? this.urlValue : window.location.href

        if (navigator.share) {
            navigator.share({ title, url })
            return
        }

        this.copyToClipboard(url)
            .then(() => this.showToast(this.successTextValue))
            .catch(() => this.showToast(this.failTextValue))
    }

    copyToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text)
        }
        return new Promise((resolve, reject) => {
            const input = document.createElement('input')
            input.value = text
            document.body.appendChild(input)
            input.select()
            try {
                document.execCommand('copy') ? resolve() : reject()
            } catch (e) {
                reject(e)
            } finally {
                document.body.removeChild(input)
            }
        })
    }

    showToast(message) {
        const container = document.getElementById('toast-container') || document.body
        const templateHolder = document.getElementById('toast-template')
        let toast

        if (templateHolder) {
            const templateToast = templateHolder.querySelector('.toast')
            if (templateToast) {
                toast = templateToast.cloneNode(true)
                toast.id = ''
                toast.classList.remove('d-none')
                // Update message
                const body = toast.querySelector('.toast-body')
                if (body) body.textContent = message
                // Ensure autohide is quick
                toast.setAttribute('data-bs-delay', '1200')
                toast.setAttribute('data-controller', 'toast')
            }
        }

        if (!toast) {
            // Fallback to a simple dark toast if template missing
            toast = document.createElement('div')
            toast.className = 'toast align-items-center text-white bg-dark border-0'
            toast.setAttribute('role', 'status')
            toast.setAttribute('aria-live', 'polite')
            toast.setAttribute('aria-atomic', 'true')
            toast.setAttribute('data-controller', 'toast')
            toast.setAttribute('data-bs-autohide', 'true')
            toast.setAttribute('data-bs-delay', '1200')
            toast.style.minWidth = '20em'
            toast.style.marginBottom = '0.5em'
            toast.innerHTML = `
        <div class="d-flex">
          <div class="toast-body">${message}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      `
        }

        container.appendChild(toast)

        // If bootstrap is available, ensure disposal after hidden
        try {
            const instance = new bootstrap.Toast(toast)
            toast.addEventListener('hidden.bs.toast', () => {
                instance.dispose()
                toast.remove()
            }, { once: true })
        } catch (e) {
            // Fallback auto-remove
            setTimeout(() => toast.remove(), 1300)
        }
    }
}


